var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { GET_LATEST_STORIES, GET_LATEST_STORIES_SUCCESS, GET_LATEST_STORIES_ERROR } from "../constants/actionTypes";

var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_LATEST_STORIES:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case GET_LATEST_STORIES_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case GET_LATEST_STORIES_ERROR:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});


// WEBPACK FOOTER //
// ./src/reducers/latestStories.js